<!-- dialogResult.vue -->
<template>
  <div class="modal" v-if="isShowPopup">
    <div class="modal-content banner-home-page">
      <div class="modal-header-frame">
        <div
          @click="closeModal"
          style="position: absolute; top: 10px; right: 10px; border-radius: 50%;
          padding: 5px;
          background: #ffffff;"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.9543 0.000173286C11.7914 0.00402044 11.6366 0.0721647 11.5238 0.189728L6.29285 5.42065L1.06194 0.189728C0.94577 0.0700984 0.786125 0.00258954 0.619375 0.00258289C0.368256 0.00264415 0.142234 0.154914 0.0478465 0.38762C-0.0465412 0.620326 0.00954382 0.887022 0.189666 1.062L5.42058 6.29292L0.189666 11.5238C0.0285237 11.6786 -0.0363867 11.9083 0.0199679 12.1245C0.0763224 12.3406 0.245136 12.5095 0.461304 12.5658C0.677472 12.6222 0.907217 12.5573 1.06194 12.3961L6.29285 7.1652L11.5238 12.3961C11.6785 12.5573 11.9082 12.6222 12.1244 12.5658C12.3406 12.5095 12.5094 12.3406 12.5657 12.1245C12.6221 11.9083 12.5572 11.6786 12.396 11.5238L7.16512 6.29292L12.396 1.062C12.5796 0.885781 12.6362 0.614908 12.5384 0.379948C12.4407 0.144988 12.2087 -0.00583745 11.9543 0.000173286Z"
              fill="#090710"
            />
          </svg>
        </div>
        <img @click="handleRedirect" :src="objectData.url" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "popup-banner",
  props: {
    isShowPopup: {
      type: Boolean,
      required: true
    },
    objectData: {
      default: {
        url:
          "https://handee-hcm.s3.ap-southeast-1.amazonaws.com/loyal-policy-order-tablet-2.jpg"
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleRedirect() {
      {
        if (!this.objectData.link_redirect) return;
        window.open(this.objectData.link_redirect, "_blank");
      }
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.modal-content {
  margin: 10px;
  position: relative;
  background-color: #ffff;
  animation: modalFadeIn 0.3s ease-in-out;
  border: none;
}
@keyframes modalFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header-frame {
  position: relative;
  overflow: hidden;
  background-color: transparent;
}
.modal-header-frame svg {
  display: block;
}

@media screen and (max-width: 350px) {
  .modal-header-frame .title-dialog {
    font-size: 12px;
  }
}

.banner-home-page {
  max-width: 790px;
}
</style>
